export default "__VITE_ASSET__D4ffP63R__"